const IS_SAFARI = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);

if (IS_SAFARI) document.documentElement.classList.add('is-safari');

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.submenuPlaceholder = null;
    this.mainDetailsToggle.querySelector('summary').addEventListener(
      'pointerdown',
      this.closeSiblingMenus.bind(this)
    );
  }

  closeSiblingMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.hasAttribute('open')) menu.close();
    });
  }

  // Safari-only: detach submenu so WebKit drops the stale compositor layer.
  hideContent() {
    if (!IS_SAFARI || !this.content) return;

    this.content.getAnimations().forEach((animation) => animation.cancel());
    this.content.style.cssText = '';

    if (this.content.parentNode === this.mainDetailsToggle) {
      this.submenuPlaceholder = document.createComment('header-submenu');
      this.mainDetailsToggle.replaceChild(this.submenuPlaceholder, this.content);
    }
  }

  showContent() {
    if (!IS_SAFARI || !this.content) return;

    if (this.submenuPlaceholder?.parentNode) {
      this.submenuPlaceholder.parentNode.replaceChild(this.content, this.submenuPlaceholder);
      this.submenuPlaceholder = null;
    }

    this.content.style.cssText = '';
  }

  close() {
    this.hideContent();
    super.close();
  }

  onToggle() {
    if (this.mainDetailsToggle.open) {
      this.closeSiblingMenus();
      this.showContent();
    } else {
      this.hideContent();
    }

    if (!IS_SAFARI) super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
